export default __webpack_public_path__ + "static/media/debate_6.577e877a.JPG";